<template>
  <div class="i-chart-warpper">
    <div class="unconnected" v-if="!needRefresh">
      <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-alert-circle"></use>
      </svg>
      Disconected
    </div>
    <img class="i-charts-alarm" slot="reference" :src="marker_alarm" v-if="onAlarm" />
    <svg class="icon" style="font-size:120px;" aria-hidden="true" v-if="datas.Door == 1">
        <use xlink:href="#icon-guanmen"></use>
    </svg>
    <svg class="icon" style="font-size:120px;" aria-hidden="true" v-else>
        <use xlink:href="#icon-kaimen"></use>
    </svg>
    <span class="imt-2 headline">{{ `Door ${door(datas.Door) || '- -'}`}}</span>
  </div>
</template>

<script>
import { door } from '../convert'
export default {
  props: {
    datas: {
      type: Object,
      default: () => ({})
    },
    onAlarm: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    needRefresh() {
      return this.datas.Status == 3 || this.datas.Status == 2
    }
  },
  methods: {
    door
  },
  created() {
    this.marker_alarm = require('../../../assets/icon/alarm.gif')
  }
}
</script>

<style lang="scss" scoped>
.i-chart-warpper {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  .i-charts-alarm {
    position: absolute;
    top: 10px;
    left: 10px;
    width: 40px;
    height: 40px;
    z-index: 100;
  }
  .unconnected {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(96,125,139,.4);
    text-align: center;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    color: #FFF;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/charts/chart-door.vue